var breakpoint = window.matchMedia('(max-width: 350px)');

var categoryList = document.querySelector('.faq__Categories');
var categoryListLinks = document.querySelectorAll('.faq__Categories_Link');
var categorySections = document.querySelectorAll('.faq__Category');
var questionButtons = document.querySelectorAll('.faq__Question_Button');
var backBtn = document.querySelector('.faq_Back');

questionButtons.forEach(function(btn){
  var category = btn.parentNode.parentNode;
  var question = btn.parentNode

  btn.addEventListener('click', function(e){
    if(question.classList.contains('is-active')) {
      question.classList.remove('is-active');

      return;
    }

    category.querySelector('.faq__Question.is-active') && category.querySelector('.faq__Question.is-active').classList.remove('is-active');

    question.classList.add('is-active');
  });
});

function linkClick(btn) {
  if (breakpoint.matches) {
    categoryList.classList.add('is-hidden');
    backBtn.classList.add('is-visible');
  } else {
    if (btn.classList.contains('is-active')) {
      // If the clicked link is already active, close the category
      btn.classList.remove('is-active');
      document.querySelector('.faq__Category.is-active').classList.remove('is-active');
      return;
    }

    document.querySelector('.faq__Categories_Link.is-active') && document.querySelector('.faq__Categories_Link.is-active').classList.remove('is-active');
    document.querySelector('.faq__Category.is-active') && document.querySelector('.faq__Category.is-active').classList.remove('is-active');
    document.querySelector('.faq__Question.is-active') && document.querySelector('.faq__Question.is-active').classList.remove('is-active');

    btn.classList.add('is-active');
  }

  document.querySelector('.faq__Category[data-category="' + btn.dataset.category + '"]').classList.add('is-active');
}


document.querySelectorAll('.faq__Categories_Link').forEach(btn => {
  btn.addEventListener('click', function() {
    linkClick(btn);
    faqQuestionButton.click();
  });
});

/**
 * Click listener for 'back to categories' button
 */
backBtn.addEventListener('click', function(){
  categoryList.classList.remove('is-hidden');

  document.querySelector('.faq__Category.is-active').classList.remove('is-active');

  backBtn.classList.remove('is-visible');
});

function checkBreakpoint() {
  if (breakpoint.matches) {
    document.querySelector('.faq__Categories_Link.is-active') && document.querySelector('.faq__Categories_Link.is-active').classList.remove('is-active');
    document.querySelector('.faq__Category.is-active') && document.querySelector('.faq__Category.is-active').classList.remove('is-active');
  } else {
    categoryList.classList.contains('is-hidden') && categoryList.classList.remove('is-hidden');
    backBtn.classList.contains('is-visible') && backBtn.classList.remove('is-visible');

    if (document.querySelector('.faq__Category.is-active')) {
      document.querySelector('.faq__Categories_Link[data-category="' + document.querySelector('.faq__Category.is-active').dataset.category + '"]').classList.add('is-active');
      document.querySelector('.faq__Category.is-active').classList.remove('is-active'); 
    } else {
      
      categoryListLinks[0].classList.add('is-active');
      categorySections[0].classList.add('is-active');
      categoryListLinks[0].classList.remove('is-active'); 
      categorySections[0].classList.remove('is-active'); 
    }
  }
}


document.addEventListener("DOMContentLoaded", function () {
  var faqCategories = document.querySelectorAll(".faq__Categories_Link");

  if (faqCategories.length === 1) {

    var faqQuestionButton = document.querySelector(".faq__Question_Button");
    if (faqQuestionButton) {
      faqQuestionButton.click();
    }
  }
  setupCategoryLinks();
});



breakpoint.addListener(checkBreakpoint);
checkBreakpoint();

function setupCategoryLinks() 
{
  var categoryLinks = document.querySelectorAll('.faq__Categories_Link');

  categoryLinks.forEach(function (link) 
  {
    link.addEventListener('click', function (event) 
    {
      event.preventDefault();
      var isActive = link.classList.contains('is-active');
      categoryLinks.forEach(function (otherLink) 
      {
        otherLink.classList.toggle('is-active');
      });
      link.classList.toggle('is-active');
      categoryLinks.forEach(function (otherLink) 
      {
        if (otherLink !== link) 
        {
          otherLink.classList.toggle('hide', isActive);
        }
      });
    });
  });
}

window.addEventListener('DOMContentLoaded', (event) => 
{
  const currentURL = window.location.href;
  if (currentURL.includes("/pages/about-us")) 
  {
    const linkElement = document.querySelector('.faq__Categories_Link');
    const questionElement = document.querySelector('.faq__Question');
    const categoryElement = document.querySelector('.faq__Category');
    if (linkElement && questionElement) 
    {
      linkElement.classList.add('is-active');
      questionElement.classList.add('is-active');
      categoryElement.classList.add('is-active');
    }
  }
});

